import api from "./apiConfig";

export const CREATE_FISCALIZACION = async (data) => {
	try {
		const response = await api.post("/taxTaxation", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_FISCALIZACION_BY_CASO = async (id) => {
	try {
		const response = await api.get(`/taxTaxation/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_FISCALIZACION = async (id, data) => {
	try {
		const response = await api.put(`/taxTaxation/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};